import React, {
  useEffect,
  useState,
  useCallback,
  useRef,
  useReducer,
} from "react"
import PropTypes from "prop-types"
import { AvField } from "availity-reactstrap-validation"
import Select from "react-select"
import classnames from "classnames"

import { debounce } from "lodash"

// import AsyncSelect from "react-select/async"


import { getI18nextLng, isEmptyArray } from "helpers/utilities"
import { useDetectedChanges } from "helpers/hooks"

import { parameterCode, TestProfileTypeText, TestProfileStatus } from "constant/utility"
import { Label } from "reactstrap"
import { RollbackButton } from "."
import { isEmpty } from "lodash"

const CustomSelectAsync = ({
  value,
  name,
  required,
  errorMessage,
  code,
  group,
  onChange,
  isDependent,
  isMulti,
  portal,
  label,
  detected,
  options,
  readOnly,
  valueName,
  showDefaultAll,
}) => {
  const [defaultValue, setDefaultValue] = useState()
  const [inputValue, setInputValue] = useState()

  const inputId = new Date().getTime()

  const [state, setState] = useReducer(
    (state, newState) => ({ ...state, ...newState }),
    { loading: false, items: [] }
  )

  const inputRef = useRef()
  const [valueInput, isChanged] = useDetectedChanges(
    value,
    isMulti ? defaultValue : defaultValue?.[0]
  )

  const onUndoHandler = () => {
    onInputChangeHandler(inputValue)
    onChangeHandler(
      isMulti ? (isEmpty(valueInput) ? [] : valueInput) : { value: valueInput }
    )
  }

  const isTouched = inputRef.current?.FormCtrl.isTouched()
  const isDirty = inputRef.current?.FormCtrl.isDirty()
  const isInvalid =
    !readOnly &&
    required &&
    isEmptyArray(defaultValue) &&
    (isTouched || isDirty)

  let lang = getI18nextLng()


  const fetchTestProfileMapping = async keySearch => {
    if (keySearch === valueName)
      keySearch = ''

    const query = {
      status: TestProfileStatus.ACTIVE,
      search: keySearch,
      size: 15
    }

    const res = await getAllTestProfiles(query)
    const result = []
    if (res.data) {
      res.data.map(_prof =>
        result.push(
          {
            label: `${_prof.profileName} (${_prof.code})`,
            value: _prof.code
          })
      )
    }

    if (!valueName && valueName === "" && result.findIndex(x => x.value === value) < 0) {
      result.unshift({
        value: value,
        label: valueName
      })
    }

    return result
  }

  const fetchBookingTable = async keySearch => {
    if (keySearch === valueName)
      keySearch = ''

    const query = {
      search: keySearch,
      size: 15
    }

    // const res = await getAllTestProfiles(query)
    const res = {
      data: [{
        id: 1,
        name: "A1",
        type: "",
        typeName: ""
      },
      {
        id: 2,
        name: "A2",
        type: "",
        typeName: ""
      },
      {
        id: 3,
        name: "A3",
        type: "",
        typeName: ""
      },
      {
        id: 4,
        name: "A4",
        type: "",
        typeName: ""
      }]
    }
    const result = []
    if (res.data) {
      res.data.map(_prof =>
        result.push(
          {
            label: `${_prof.name}`,
            value: _prof.id
          })
      )
    }

    if (!valueName && valueName === "" && result.findIndex(x => x.value === value) < 0) {
      result.unshift({
        value: value,
        label: valueName
      })
    }

    return result
  }

  const fetchBookingUser = async keySearch => {
    if (keySearch === valueName)
      keySearch = ''

    const query = {
      search: keySearch,
      size: 15,
      onlyActive: true,
    }

    const res = await getAllEmployees(query)
    const result = []
    if (res.data) {
      res.data.map(_prof =>
        result.push(
          {
            label: `${_prof.code} - ${_prof.name}`,
            value: _prof.id
          })
      )
    }
    if (valueName && valueName !== "" && result.findIndex(x => x.value === value) < 0) {
      result.unshift({
        value: value,
        label: valueName
      })
    }
    return result
  }

  const fetchTests = async keySearch => {
    if (keySearch === valueName)
      keySearch = ''
    const query = {
      size: 15,
      search: keySearch,
      inUse: true,
    }
    const res = await getAllTests(query)

    let data = []
    if (res.data)
      data = res.data.map(_item => {
        _item.value = _item.testCode
        _item.label = `${_item.testName} (${_item.testCode})`
        return _item
      })
    if (valueName && valueName !== "" && data.findIndex(x => x.value === value) < 0) {
      data.unshift({
        value: value,
        label: valueName
      })
    }
    return data
  }

  // COMPANIES
  const fetchCompanies = async value => {
    const query = { size: 15, search: value }
    const res = await getAllCompanies(query)
    let data = []
    if (res.data)
      data = res.data.map(_item => {
        _item.value = _item.id
        _item.label = _item.name
        return _item
      })

    return data
  }

  // DEPARTMENTS
  const fetchDepartments = async (value, group) => {
    const query = { size: 15, search: value, companyId: group }
    const res = await getAllDepartments(query)
    let data = []
    if (res.data)
      data = res.data.map(_item => {
        _item.value = _item.id
        _item.label =
          lang === "vi" ? _item.name : _item.englishName || _item.name
        return _item
      })

    return data
  }

  // ROLES
  const fetchRoles = async () => {
    const query = { size: 100 }
    const res = await getAllRoles(query)
    let data = []
    if (res.data)
      data = res.data.map(_item => {
        _item.value = _item.id
        _item.label = _item.roleName
        return _item
      })

    return data
  }

  // USERS
  const fetchUsers = async value => {
    const query = { size: 15, search: value }
    const res = await getAllUsers(query)
    let data = []
    if (res.data)
      data = res.data.map(_item => {
        _item.value = _item.id
        _item.label = _item.familyName + " " + _item.givenName
        return _item
      })

    return data
  }

  // PROFILES
  const fetchParties = async (profileId, value) => {
    const query = { size: 15, profileId, search: value }
    const res = await getAllParties(query)
    let data = []
    if (res.data)
      data = res.data.map(_item => {
        _item.value = _item.id
        _item.label = _item.name
        return _item
      })

    return data
  }

  // TESTPROFILES
  const fetchTestProfiles = async keySearch => {
    if (keySearch === valueName)
      keySearch = ''
    const query = {
      size: 100,
      search: keySearch,
      type: TestProfileTypeText.PROFILE,
      status: TestProfileStatus.ACTIVE,
    }
    const res = await getAllTestProfiles(query)
    let data = []
    if (res.data)
      data = res.data.map(_item => {
        _item.value = _item.id
        _item.label = _item.profileName
        return _item
      })
    if (valueName && valueName !== "" && data.findIndex(x => x.value === value) < 0) {
      data.unshift({
        value: value,
        label: valueName
      })
    }
    return data
  }

  //tests
  const fetchAllTests = async keySearch => {
    if (keySearch === valueName)
      keySearch = ''
    const query = {
      size: 100,
      search: keySearch,
      inUse: true,
    }
    const res = await getAllTests(query)
    let data = []
    if (res.data)
      data = res.data.map(_item => {
        _item.value = _item.id
        _item.label = `${_item.testCode} - ${_item.testName}`
        return _item
      })
    if (valueName && valueName !== "" && data.findIndex(x => x.value === value) < 0) {
      data.unshift({
        value: value,
        label: valueName
      })
    }
    if (showDefaultAll) {
      data.unshift({
        value: 0,
        label: 'All'
      })
    }
    return data
  }

  //parameters
  const fetchAllParametersConnector = async (keySearch, group) => {
    if (keySearch === valueName)
      keySearch = ''
    const query = {
      size: 15,
      search: keySearch,
      type: group
    }
    const res = await getAllParameters(query)
    let data = []
    if (res.data)
      data = res.data.map(_item => {
        _item.value = _item.parameterKey
        _item.label = `${_item.name}`
        return _item
      })
    if (data.findIndex(x => x.value === value) < 0 && value) {
      data.unshift({
        value: value,
        label: valueName
      })
    }
    return data
  }

  const fetchOptions = useCallback(async (code, group, value) => {
    setState({ loading: true })
    let res = []
    if (code === parameterCode.COMPANIES) {
      res = await fetchCompanies(value)
    } else if (code === parameterCode.DEPARTMENTS) {
      res = await fetchDepartments(value, group)
    } else if (code === parameterCode.ROLES) {
      res = await fetchRoles()
    } else if (code === parameterCode.USERS) {
      res = await fetchUsers(value)
    } else if (code === parameterCode.TESTPROFILE) {
      res = await fetchTestProfiles(value)
    } else if (code === parameterCode.TESTPROFILE_TEST) {
      res = await fetchAllTests(value)
    } else if (code === parameterCode.HISCONNECTOR) {
      res = await fetchAllParametersConnector(value, group)
    } else if (group === parameterCode.HIS_MAPPING_KEY) {
      res = await fetchCodesByParameterId(code, value)
    } else if (code === parameterCode.LIS_MAPPING_KEY) {
      res = await fetchTests(value)
    } else if (code === parameterCode.LIS_PROFILE_MAPPING_KEY) {
      res = await fetchTestProfileMapping(value)
    } else if (code === parameterCode.BookingTable) {
      res = await fetchBookingTable(value)
    } else if (code === parameterCode.BookingUser) {
      res = await fetchBookingUser(value)
    } else if (code.indexOf("_") >= 0 || code === parameterCode.PROFILE) {
      const profileId = code.substring(code.indexOf("_") + 1)
      if (profileId > 0) res = await fetchParties(profileId, value)
      else res = await fetchParties(undefined, value)
    } else {
      res = await fetchCodes(code, group)
    }

    // setItems(data)
    setState({ items: res, loading: false })
  }, [])

  const onChangeHandler = (e, b) => {
    const element = document.getElementById(name + "" + inputId)
    var event = new Event("change", { bubbles: true })

    // console.log(e, b)
    const value =
      (isMulti
        ? e?.map(_value => {
          return _value.value
        })
        : [e?.value]) || []

    element.value = value || ""
    element.dispatchEvent(event)

    // console.log(value, document.getElementsByName(name))

    setDefaultValue(value || "")
    onChange(name, value)
  }

  const isValidStyle = isInvalid && {
    borderColor: "#f46a6a !important",
    backgroundImage: `url(
    "data:image/svg+xml,<svg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 12 12' width='12' height='12' fill='none' stroke='%23f46a6a'><circle cx='6' cy='6' r='4.5'/><path stroke-linejoin='round' d='M5.8 3.6h.4L6 6.5z'/><circle cx='6' cy='8.2' r='.6' fill='%23f46a6a' stroke='none'/></svg>"
  )`,
    backgroundPosition: "right 2.75rem center, center right 0.5rem",
    backgroundSize: "17px 18px, calc(0.75em + 0.47rem) calc(0.75em + 0.47rem)",
    backgroundRepeat: "no-repeat",
  }

  const colourStyles = {
    control: (styles, { data, isDisabled, isFocused, isSelected }) => ({
      ...styles,
      backgroundColor: isDisabled ? "#edf1f2 !important" : "white",
      fontSize: "13px",
      cursor: isDisabled ? "not-allowed" : "default",
      ...isValidStyle,
      // ...isVaild,
    }),
    option: (styles, { data, isDisabled, isFocused, isSelected }) => {
      // const color = chroma(data.color);
      return {
        ...styles,
        fontSize: "13px",
        // color: "black",
        // backgroundColor: isDisabled ? null : isSelected ? data.color : null,
        cursor: isDisabled ? "not-allowed" : "default",
      }
    },
    singleValue: (provided, state) => {
      const opacity =
        state.isDisabled || !state.data.value || state.data.value === "0"
          ? 0.7
          : 1
      const transition = "opacity 300ms"

      return { ...provided, opacity, transition }
    },

    menuPortal: provided => ({
      ...provided,
      zIndex: 9999,
    }),
    menu: provided => ({ ...provided, zIndex: 9999 }),
  }

  const onInputChangeHandler = debounce(value => {
    if (value?.length > 1 && code && (!isDependent || (isDependent && group))) {
      setState({ loading: true })
      fetchOptions(code, group, value)
    }
  }, 800)

  useEffect(() => {
    if (code && isDependent && group) fetchOptions(code, group)
    else setState({ items: [] })
  }, [code, group, isDependent])

  useEffect(() => {
    onInputChangeHandler(inputValue)
  }, [inputValue, code, group, isDependent])

  useEffect(() => {
    setDefaultValue(isMulti ? value : [value])
    setInputValue(valueName)
  }, [value, valueName])

  useEffect(() => {
    if (!isEmpty(options)) {
      if (valueName && valueName !== "" && options.findIndex(x => x.value === value) < 0) {
        options.unshift({
          value: value,
          label: valueName
        })
      }
      setState({ items: options })
    }
  }, [options])

  // console.log(defaultValue, inputValue)

  return (
    <>
      <div className="label-group-relative position-relative">
        {label && (
          <Label for={name}>
            {label}
            {required && <span className="text-danger">*</span>}
          </Label>
        )}

        <RollbackButton
          display={isChanged && detected}
          onClick={onUndoHandler}
        />
      </div>
      <Select
        isClearable
        isLoading={state.loading}
        // inputValue={inputValue}
        onInputChange={onInputChangeHandler}
        menuPlacement="auto"
        maxMenuHeight={150}
        menuPortalTarget={!portal && document.body}
        styles={colourStyles}
        isDisabled={readOnly}
        isMulti={isMulti}
        value={state.items.filter(
          _item =>
            defaultValue?.findIndex(
              _defaultValue =>
                JSON.stringify(_defaultValue + "") ===
                JSON.stringify(_item.value + "")
            ) >= 0
        )}
        onChange={onChangeHandler}
        options={state.items}
        classNamePrefix="select2-selection"
        className={classnames(
          { "has-changed": isChanged && detected },
          "form-select2 is-touched is-dirty av-invalid is-invalid"
        )}
      />
      {isInvalid && (
        <div className="text-danger form-group">
          <div className="is-touched is-dirty av-invalid is-invalid"></div>
          <div className="invalid-feedback">{errorMessage}</div>
        </div>
      )}
      <div className="d-none">
        <AvField
          multiple={isMulti}
          name={name}
          id={name + "" + inputId}
          type="select"
          className={`form-select`}
          value={isMulti ? defaultValue : defaultValue?.[0]}
          errorMessage={errorMessage}
          required={!readOnly && required}
          ref={inputRef}
          readOnly={readOnly}
        >
          <option value="">--Select--</option>
          {state.items.map((_item, idx) => (
            <option key={idx} value={_item.value}>
              {_item.label}
            </option>
          ))}
        </AvField>
      </div>
    </>
  )
}

CustomSelectAsync.propTypes = {
  onChange: PropTypes.func,
  name: PropTypes.string.isRequired,
  isDependent: PropTypes.bool,
  required: PropTypes.bool,
  errorMessage: PropTypes.string,
  value: PropTypes.any,
  valueName: PropTypes.string.isRequired,
  group: PropTypes.string,
  code: PropTypes.string,
  isMulti: PropTypes.bool,
  portal: PropTypes.bool,
  label: PropTypes.any.isRequired,
  detected: PropTypes.bool,
  options: PropTypes.array,
  readOnly: PropTypes.bool,
  showDefaultAll: PropTypes.bool,
}

CustomSelectAsync.defaultProps = {
  name: "",
  onChange: () => { },
  isDependent: false,
  errorMessage: "This field is invalid",
  portal: false,
}

export default CustomSelectAsync
